import { mutatorAction } from 'satcheljs';
import { getStore } from 'owa-immersive-reader-store';
var setImmersiveReaderFrameReady = mutatorAction('setImmersiveReaderFrameReady', function () {
    getStore().immersiveReaderFrameState = 2 /* Ready */;
});
export default setImmersiveReaderFrameReady;
//# sourceMappingURL=setImmersiveReaderFrameReady.js.map